<template>
	<div class="dropdown">
	  <div>
	    <span class="dropdown-button">
	      <button type="button" id="options-menu" aria-haspopup="true" aria-expanded="true" @click="toggle">
	        Options
	        <svg viewBox="0 0 20 20" fill="currentColor">
	          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
	        </svg>
	      </button>
	    </span>
	  </div>

	  <div class="dropdown-panel-container" :class="{'show': showing}">
	    <div class="dropdown-panel">
	      <div class="dropdown-menu" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
	        <a :href="option.link" v-for="option in options" class="dropdown-menu-item" role="menuitem">{{ option.text }}</a>
	      </div>
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		name: 'element.dropdown',
		props: ['options'],
		data() {
			return {
				showing: false,
			}
		},
		methods: {
			toggle() {
				if(this.showing) {
					this.showing = false;
				} else {
					this.showing = true;
				}
			}
		}
	}
</script>